export enum ProductStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
    DRAFT = "DRAFT",
    ARCHIVED = "ARCHIVED",
}

export enum ProductGroup {
    AUTO_INSURANCE = "AUTO_INSURANCE",
    TOURISM = "TOURISM",
    PROPERTY = "PROPERTY",
}

export enum ProductGroupTitles {
    AUTO_INSURANCE = "Авто страхування",
    TOURISM = "Туризм",
    PROPERTY = "Власність",
}

export enum ProductTypes {
    AUTO_CIVIL_LIABILITY = "AUTO_CIVIL_LIABILITY",
    GREEN_CARD = "GREEN_CARD",
    TOURISM = "TOURISM",
    AUTO_PROTECTION = "AUTO_PROTECTION",
}

export enum ProductTypesTitles {
    AUTO_CIVIL_LIABILITY = "Автоцивілка",
    GREEN_CARD = "Зелена картка",
    TOURISM = "Туризм",
    AUTO_PROTECTION = "Авто страховка",
}
